import { render } from "./HighlightsDetail.vue?vue&type=template&id=03219c8c&scoped=true"
import script from "./HighlightsDetail.vue?vue&type=script&lang=js"
export * from "./HighlightsDetail.vue?vue&type=script&lang=js"

import "./HighlightsDetail.vue?vue&type=style&index=0&id=03219c8c&scoped=true&lang=css"

import exportComponent from "/var/lib/jenkins/workspace/production-allsports-2/production-as-fe-ASPN/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-03219c8c"]])

export default __exports__